import { getIn } from 'seamless-immutable';
import { dispatchEvent, createProject, createNavigation, createContext, createMainOffer } from '../helpers';

const fmtFreightPayload = (freight, context) => {
  const hasError = getIn(freight, ['error']);
  const id = getIn(freight, ['freightId']);

  if (hasError) {
    const errorCode = getIn(freight, ['error', 'errorCode']);
    const message = getIn(freight, ['error', 'message']);
    const cep = getIn(context, ['c_cep']);

    return { errorCode, message, cep, id };
  }

  const options = getIn(freight, ['options'], [])?.map(option => ({ ...option, id: option.optionId || option.type }));

  return { ...freight, id, options };
};

export const freightEvent = ({ routerProps, client, body }) => {
  const offer = createMainOffer({ routerProps, client, body });
  const context = createContext({ client });
  const freight = fmtFreightPayload(getIn(body, ['freight'], {}), context);
  const hasError = getIn(body, ['freight', 'error']);
  const eventName = hasError ? 'freight:error' : 'freight:calculate';

  const options = freight?.options || [];
  const products = options[0]?.products || [];
  const hasFreightIncentive = products.some(
    ({ freightIncentive }) => freightIncentive?.code === 'MORE_UNIT_FOR_CHEAPER_FREIGHT'
  );

  const payload = {
    mainOffer: offer && offer.id,
    context,
    offer,
    navigation: createNavigation(),
    project: createProject({ client }),
    sid: context['c_b2wSid'],
    freight: { ...freight, origin: 'product' },
    freightIncentive: hasFreightIncentive,
  };

  dispatchEvent(eventName, payload);
};
